import React, {useEffect, useState} from 'react';
import {useHistory, useLocation} from "react-router";
import axios from "axios";
import {strings} from "../../../strings";
import {Redirect} from "react-router";
import {LoadingComponents} from "../../module";
import nutFoundImage from "../../../Image/404.png";

function My404Component() {

    const [redirect, setRedirect] = useState(false);
    const [newUrl, setNewUrl] = useState("");
    const [loading, setLoading] = useState(false);

    let location = useLocation();
    let history = useHistory();

    async function fetchData() {
        setLoading(true);
        await axios.post(strings.baseUrl + `old-url?url=${location.pathname.substring(1)}`)
            .then(result => {
                if (result.data.status_code === 200) {
                    setNewUrl(result.data.data.new_url);
                    setRedirect(true)
                }
            })
            .catch(error => {
                console.log(error)
            })
        setLoading(false);
    }

    useEffect(() => {
        if (location.pathname.includes("product")) {
            fetchData()
        } history.push("/")

    }, []);

    return (
        redirect ?
            <Redirect to={`/products/${newUrl}`}/>
            :
            <div className="d-flex justify-content-center align-items-center h-100">
                {loading ?
                    <LoadingComponents/>
                    :
                    <img src={nutFoundImage} alt=""/>
                }
            </div>
    );
}

export default My404Component;